module.exports = __webpack_public_path__ + "img/8.75b90e29.png";